import React, { useEffect, useState } from 'react'
import Loader from '../components/Loader'
import { Link } from 'react-router-dom'
import axiosInstance from '../utils/api'

type Props = {}

const CreateSerial = (props: Props) => {
    const [loading, setLoading] = useState(false)
    const [serialList, setSerialList] = useState([])
    const [selectedSerial, setSelectedSerial] = useState()
    const [timeLeft, setTimeLeft] = useState(0)

    useEffect(() => {
        setLoading(true)
        axiosInstance.get("https://api.cl-ds.com/internal/production/v1.0/page/register/serial").then(res => {
            setLoading(false)
            console.log("res", res.data)
            setSerialList(res.data)
        }).catch (err => {
            setLoading(false)
            console.log("err", err)
        })
    }, [])
    
    function handleCreateSerial() {
        // value={input.board} onChange={(e)=>handleChangeSelect(e, "board")}
        console.log("handleCreateSerial", selectedSerial)
        setTimeLeft(240)
        setLoading(true)
        axiosInstance.post(`https://api.cl-ds.com/internal/production/v1.1/register/serial/${selectedSerial}/`).then(res => {
            setLoading(false)
            setTimeLeft(0)
            console.log("res", res)
            alert(res.data.msg)
        }).catch (err => {
            setLoading(false)
            setTimeLeft(0)
            console.log("err", err)
            if (err.response.status == 500) {
                return alert("Server Error")
            }
            alert("Timeout. Please notify administrator.")
        })
    }

    useEffect(() => {
        // exit early when we reach 0
        if (!timeLeft) return;
    
        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {
          setTimeLeft(timeLeft - 1);
        }, 1000);
    
        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
      }, [timeLeft]);

    return (
        <div className="col-12">
            {loading && ( <>
                <Loader/>
                {timeLeft && (
                <div className="d-flex justify-content-center" style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                }}>
                    <div style={{
                        alignSelf: "center",
                        opacity: 1,
                    }}>
                    {timeLeft}
                    </div>
                </div>
                )}
            </> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link to={`/`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">Create Serial</h5>

                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label">Product</label>
                        <div className="col-sm-8">
                            <select className="form-select" aria-label="select" value={selectedSerial} onChange={(e:any)=>{setSelectedSerial(e.target.value)}}>
                                <option value={0} key={0}>-- Please Select --</option>
                                {serialList.map((serial:any) => (
                                    <option value={serial.id} key={serial.id}>{serial.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleCreateSerial()}>Create Serial</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default CreateSerial